import modules from "@/store/index.js";
import { analyticsLogEvent, analyticsSetUserId } from "@/plugins/firebase.js";
import { handleStatusBar } from "@/plugins/statusbar.plugins.js";
import { handleSplashscreen } from "@/plugins/splashscreen.plugins.js";
import { handleCopyLayer } from "@/plugins/copy.plugins.js";
import mixin from '@/mixin/index.js';
const { _decrypt } = mixin.methods;
const root = { root: true };

const removeLinkRedirect = () => {
    localStorage.removeItem('link_redirect');
    modules.commit("general/setLinkRedirect", null, root);
}

const handlePageZoom = function (to) {
    let metaTag = "width=device-width,initial-scale=1.0,height=device-height,viewport-fit=cover"
    if (!to.meta.allowZoom) {
        metaTag += ",maximum-scale=1.0,user-scalable=no";
    }
    let el = document.getElementById("vetalfa-viewport-meta");
    el.setAttribute('content', metaTag);
}

const handlePageScrolling = function (to) {
    document.body.style = !!to.meta.scrolling ?
        "overflow:auto!important;position:absolute!important;width:100%;" :
        "overflow:hidden!important;position:fixed!important;width:100%;";
}

const redirect = function (from, to, next, user) {
    handleSplashscreen();
    handleStatusBar(to.meta);
    handleCopyLayer(to);
    handlePageZoom(to);
    handlePageScrolling(to);

    if (localStorage.getItem('link_redirect')) {
        try {
            let link_redirect = localStorage.getItem('link_redirect');
            link_redirect = JSON.parse(_decrypt(link_redirect, true));
            modules.commit("general/setLinkRedirect", link_redirect, root);
        } catch {
            modules.commit("general/setLinkRedirect", null, root);
        }
    }
    if (!user && !to.meta.publicPage && to.name !== 'update') {
        if (to.path !== '/login' && !from.params.mode) {
            modules.commit("general/setLinkRedirect", to, root);
        }
        next({ path: '/login' });
    } else if (to.name === 'subscriptions') {
        return modules.dispatch("purchases/purchasesManageSubscriptions", null, root);
    } else if (modules.getters['general/link_redirect'] && to.name !== 'login' && to.name !== 'registration') {
        modules.state.general.routeCount = 0;
        modules.commit("general/setLoadingOff", false, root);
        let link_redirect = Object.assign({}, modules.getters['general/link_redirect']);
        const matchingRoutes = from.path == link_redirect.path;
        removeLinkRedirect();
        modules.commit("drugs/setProduct", null, root);
        modules.commit("drugs/setDrug", null, root);
        modules.commit("drugs/setDose", null, root);

        if (matchingRoutes && from.query.title && link_redirect.query.title && link_redirect.query.title == from.query.title) {
            next();
        } else {
            next(link_redirect);
        }
    } else if (user && to.name == "login") {
        next({ path: '/' });
    } else {
        analyticsLogEvent('page_view', { 'name': to.name });
        modules.commit("general/setLoadingOff", false, root);
        next();
    }
}

export default {
    setUser: function (from, to, next, user) {
        analyticsSetUserId(user.uid);
        modules.commit("general/setUser", user, root);
        modules.dispatch("purchases/configurePurchases", user, root);
        redirect(from, to, next, user);
    },
    route: function (path, view, meta, component) {
        return {
            name: view.split(/(?=[A-Z])/).join('-').toLowerCase(),
            path,
            component: component,
            props: true,
            meta
        };
    },
    redirect,
    handlePageZoom
}